import MaterialChip, { ChipProps } from '@mui/material/Chip';

export const Chip = (props: ChipProps) => {
    return <MaterialChip data-testid={'Chip-container'} {...props} />;
};
